// Sold-items helpers (records come from GET /saled-items).

// Delivery apps with a per-item sold count on each record: canonical app keys
// (utils/integrations.js), in table column order.
export const APPS = ["jahez", "hungerstation", "marsool", "toyou", "keeta", "ninja"];

const MONTHS = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const PERIOD_LABELS = {
  P1: "25 → 9",
  P2: "10 → 24",
};

// "D-M-YYYY" (as the backend stores fromDate/toDate); null when malformed so
// one bad record can't crash the page.
const parseDMY = (value) => {
  const [day, month, year] = String(value || "").split("-").map(Number);
  if (!day || !month || !year) return null;
  return { day, month, year };
};

// Upload periods are 25th → 9th (P1) and 10th → 24th (P2).
export const getMonthPeriod = (row) => {
  const from = parseDMY(row?.fromDate);
  const to = parseDMY(row?.toDate);
  if (!from || !to) return null;
  if (from.day === 25 && to.day === 9) return { ...from, period: "P1" };
  if (from.day === 10 && to.day === 24) return { ...from, period: "P2" };
  return null;
};

// Period filter label. Includes the year: without it, the same month of
// different years collapsed into one option and the filter mixed them.
export const getPeriodLabel = (row) => {
  const period = getMonthPeriod(row);
  if (!period) return null;
  return `${MONTHS[period.month]} ${period.year} · ${PERIOD_LABELS[period.period]}`;
};

// The backend stores an item name in either `en` or `ar` (the other is "").
// Options and filtering previously preferred different fields; one key now
// serves both.
export const getItemKey = (row) =>
  String(row?.item?.en || row?.item?.ar || "").toLowerCase();

export const getItemName = (row) => row?.item?.ar || row?.item?.en || "";

// Total sold across all apps (same formula as before).
export const getRowTotal = (row) =>
  APPS.reduce((sum, app) => sum + Number(row?.[app] || 0), 0);
